// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"z2-z"};